import { useId } from 'react'


const useUniqueId = (prefix = '') => `${prefix}${useId()}`


export default useUniqueId
